import { withStyles } from '@material-ui/core'

import { styles } from './styles'

import { UserImageDropzone as View } from './UserImageDropzone'

export const UserImageDropzone = withStyles(styles)(View)
